import React from 'react';
/** import third-party libraries in the section above, keep the ascending order */

import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
/** import mui components in the section above, keep the ascending order */

/** import widgets components in the section above, keep the ascending order */

const rootOrgMessage =
    'Any ad preset created or edited under Self Serve Root organization will be replicated into each non-deprecated self serve organization. Defining a default ad preset under Self Serve Root is not allowed to avoid conflicts.';

export const getDefaultPresetMessage = ({ defaultPresetName, isSelfServeRootOrg = false }) => {
    if (isSelfServeRootOrg) {
        return rootOrgMessage;
    }

    if (!defaultPresetName) {
        return 'No default preset set.';
    }

    return `The preset "${defaultPresetName}" will automatically apply to new ads, except when duplicating an existing ad or campaign.`;
};

const InfoAlertDefaultAdPreset = ({ defaultPresetName, isSelfServeRootOrg }) => {
    return (
        <Box sx={{ margin: 3 }}>
            <Alert severity="info" sx={{ alignItems: 'center', fontSize: '0.95rem' }}>
                {getDefaultPresetMessage({ defaultPresetName, isSelfServeRootOrg })}
            </Alert>
        </Box>
    );
};

export default InfoAlertDefaultAdPreset;
